__turbopack_context__.v({
  "relatedInfosContainer": "related-infos-module__BGZfuW__relatedInfosContainer",
  "relatedInfosInner": "related-infos-module__BGZfuW__relatedInfosInner",
  "relatedInfosTitle": "related-infos-module__BGZfuW__relatedInfosTitle",
});
